import { SUPPORTED_LOCALES, switchLocale, localeFromPath, DEFAULT_LOCALE } from '@claritio/frontend/lib/locale'
import { cn } from '@claritio/frontend/lib/utils'

// Compact EN | PL segmented switch (ENG-111). The active locale is the URL path
// prefix (the single source of truth); tapping the other one calls switchLocale,
// which persists the choice and full-reloads under the new /en|/pl prefix.
// Tap targets are sized for touch so it works on web and mobile.
export default function LanguageToggle({ className }: { className?: string }) {
  const current = localeFromPath(window.location.pathname) ?? DEFAULT_LOCALE
  return (
    <div
      role="group"
      aria-label="Language"
      className={cn('inline-flex items-center rounded-md border bg-background p-0.5', className)}
    >
      {SUPPORTED_LOCALES.map((loc) => {
        const active = loc === current
        return (
          <button
            key={loc}
            type="button"
            aria-pressed={active}
            onClick={() => { if (!active) switchLocale(loc) }}
            className={cn(
              // roomy tap target on touch (~40px), tightened on ≥sm for the header
              'min-w-[2.5rem] rounded px-2.5 py-2.5 text-xs font-semibold uppercase leading-none transition-colors sm:py-1.5',
              active ? 'bg-accent text-foreground' : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {loc}
          </button>
        )
      })}
    </div>
  )
}
